import * as actions from './compatibility-actions';
import * as mutations from './compatibility-mutations';
import { state } from './compatibility-state';

export const compatibility = {
  state,
  mutations,
  actions,
};
